import { useTranslation } from "react-i18next";
import { FormSectionComponent } from "./FormSectionComponent";
import { Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";
import { FormKeys } from "../helpers";
import { useEffect, useState } from "react";
import { fetchEezyCompanies } from "../../../../../invoices/invoiceSlice";
import { isFulfilled } from "@reduxjs/toolkit";

export const BasicInfo = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { getValues } = useFormContext();
  const translatedWorkTitles = useAppSelector(
    (state) => state.localized.workTitle,
  );

  const eezyCompanyId = getValues(FormKeys.EezyCompanyId);
  const workTitle = translatedWorkTitles[getValues(FormKeys.WorkTitleId)];
  const workLocation = getValues(FormKeys.WorkLocation);
  const address = getValues(FormKeys.Address);

  const [eezyCompanyName, setEezyCompanyName] = useState<string>("");

  // TODO - could BE supply the name instead?
  useEffect(() => {
    if (!eezyCompanyId) return;
    dispatch(fetchEezyCompanies({})).then((action) => {
      if (isFulfilled(action)) {
        const eezyCompany = action.payload.find(
          (company) => company.eezyCompanyId === eezyCompanyId,
        );
        if (eezyCompany) setEezyCompanyName(eezyCompany.name);
      }
    });
  }, [eezyCompanyId, dispatch]);

  const rows = [
    {
      title: t("common:employer"),
      component: <Typography>{eezyCompanyName}</Typography>,
    },
    {
      title: t("common:workTitle"),
      component: <Typography>{workTitle}</Typography>,
    },
    {
      title: t("common:workLocation"),
      component: <Typography>{workLocation}</Typography>,
    },
    {
      title: t("common:address"),
      component: <Typography>{address}</Typography>,
    },
  ];

  return (
    <FormSectionComponent
      title={t("order:workTitleWorkLocationAndEmployer")}
      rows={rows}
    />
  );
};
